<div>
  <div class="main-container">
    <div class="editor-container" #editorContainerElement>
      <div class="editor-container__editor">
        <div #editorElement>
          <ckeditor
            [editor]="Editor"
            [config]="config()"
            (change)="onChange($event)"
            (ready)="onReady($event)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
